<template>
    <div class="row container-folio">
        <ss-catalog-item v-for="item in items" key="item.id" :item="item"></ss-catalog-item>

        <p class="text-center" v-if="items && items.length === 0">Here is going to be placed the list of registered gyms!!!</p>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import ssCatalogItem from './ss_catalog_item.vue';

    export default {
        name: 'SsCatalogList',

        components: {
            ssCatalogItem
        },

        props: {
            items: {
                type: Array,
                default: () => ([])
            }
        },

        data: () => ({}),

        computed: {},

        methods: {}
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/common/ss_catalog_list.vue